import React from 'react'
import { FaWhatsapp } from "react-icons/fa";
import Styles from '../components/Faq.module.css'
const Faq = () => {
  return (
    <div className={Styles.containerFaq}>
        <section className={Styles.faq}>
      <h2>Perguntas frequentes</h2>
      <div className={Styles.faqContainer}>
        <details className={Styles.faqItem}>
          <summary>Quais são formas de pagamento?</summary>
          <p>Aceitamos diversas formas de pagamento, incluindo cartão de crédito (à vista ou parcelado) e PIX.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>As aulas são ao vivo?</summary>
          <p>Não. O conteúdo inteiro está gravado para que você possa assistir de onde e quando quiser.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>Quanto tempo tenho acesso ao curso?</summary>
          <p>O acesso é válido durante 12 meses. Isso significa que poderá assistir quantas vezes desejar durante esse período, no seu próprio ritmo.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>E se eu tiver dúvidas?</summary>
          <p>Você poderá tirar suas dúvidas dentro da plataforma nos comentários de cada aula.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>Onde o curso está hospedado?</summary>
          <p>O curso está hospedado na plataforma Hotmart. Você pode acessar o conteúdo de qualquer dispositivo com conexão à internet.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>Existe algum tipo de garantia?</summary>
          <p>Sim. Se você não estiver satisfeita com sua compra, poderá solicitar o reembolso em até 7 dias que devolveremos seu dinheiro, sem complicações.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>Todos os módulos já estarão disponíveis?</summary>
          <p>Não. A liberação do conteúdo será gradual e seguirá um cronograma que estará na área de membros.</p>
        </details>

        <details className={Styles.faqItem}>
          <summary>Como faço para acessar o curso?</summary>
          <p>Basta clicar no botão de inscrição, preencher seus dados e escolher a forma de pagamento. Assim que o pagamento for confirmado, o seu acesso à plataforma será enviado para o seu e-mail de cadastro.</p>
        </details>
      </div>
      <p className={Styles.duvida}>Ficou com alguma dúvida?</p>
      {/* Botão de WhatsApp para Suporte */}
      <div className={Styles.faqSuporte}>
        <a className={Styles.btnWhatsapp} href="https://wa.me/5521990766280" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp className={Styles.whatsIcon} />  QUERO FALAR COM O SUPORTE
        </a>
      </div>
    </section>
    
    </div>
  )
}

export default Faq
